import React, { forwardRef } from "react";

const PCBGuide = ({ t }, ref) => {
  const { pcbRef, priceRef, deliveryRef } = ref || {}; // 기존 ref 이름 유지 (연결 편의성)

  const styles = {
    section: { padding: "80px 20px", maxWidth: "1000px", margin: "0 auto" },
    title: {
      fontSize: "40px",
      fontWeight: "800",
      marginBottom: "50px",
      textAlign: "center",
    },
    subTitle: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "60px 0 20px",
      color: "#191f28",
    },
    text: {
      fontSize: "18px",
      color: "#4e5968",
      lineHeight: "1.8",
      whiteSpace: "pre-wrap",
      marginBottom: "30px",
    },
    mainImg: {
      width: "100%",
      borderRadius: "20px",
      marginBottom: "40px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    },

    // 종류별 그리드
    typeGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "20px",
      marginTop: "30px",
    },
    typeCard: {
      textAlign: "center",
      backgroundColor: "#f9fafb",
      padding: "15px",
      borderRadius: "16px",
    },
    typeImg: {
      width: "100%",
      height: "180px",
      objectFit: "cover",
      borderRadius: "12px",
      marginBottom: "15px",
    },
    typeCaption: { fontSize: "15px", fontWeight: "600", color: "#333d4b" },
  };

  return (
    <div style={styles.section}>
      <h1 style={styles.title}>{t.pcbGuide}</h1>

      {/* 1. PCB란? */}
      <div ref={pcbRef}>
        <h2 style={styles.subTitle}>{t.pcbIntroTitle}</h2>
        <img src="/PCB.png" alt="PCB Definition" style={styles.mainImg} />
        <p style={styles.text}>{t.pcbIntroDesc}</p>
      </div>

      {/* 2. PCB 공정 */}
      <div ref={priceRef}>
        <h2 style={styles.subTitle}>{t.pcbProcessTitle}</h2>

        {/* 현재 언어 설정(t)에 따라 한글/영어 이미지가 자동으로 교체됩니다 */}
        <img
          src={t.processImg}
          alt="PCB Manufacturing Process"
          style={styles.mainImg}
        />
      </div>

      {/* 3. PCB 종류 */}
      <div ref={deliveryRef}>
        <h2 style={styles.subTitle}>{t.pcbTypesTitle}</h2>
        <div style={styles.typeGrid}>
          {[
            { img: "/pcb_rigid.png", label: t.typeRigid },
            { img: "/pcb_flexible.png", label: t.typeFlex },
            { img: "/pcb_hdi.png", label: t.typeHDI },
            { img: "/pcb_rf.png", label: t.typeRF },
          ].map((item, index) => (
            <div key={index} style={styles.typeCard}>
              <img src={item.img} alt={item.label} style={styles.typeImg} />
              <p style={styles.typeCaption}>{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default forwardRef(PCBGuide);
